var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "container-fluid" }, [
    _c("section", { staticClass: "setting" }, [
      _vm._m(0),
      _c("section", { staticClass: "content" }, [
        _vm._m(1),
        _c("div", { staticClass: "form-filed" }, [
          _vm._m(2),
          _c(
            "div",
            { staticClass: "filed-control" },
            [
              _c("VueEditor", {
                staticStyle: { background: "rgb(255, 255, 255)" },
              }),
            ],
            1
          ),
        ]),
        _c("div", { staticClass: "form-filed" }, [
          _vm._m(3),
          _c(
            "div",
            { staticClass: "filed-control" },
            [
              _c("VueEditor", {
                staticStyle: { background: "rgb(255, 255, 255)" },
              }),
            ],
            1
          ),
        ]),
        _c("div", { staticClass: "form-filed" }, [
          _vm._m(4),
          _c(
            "div",
            { staticClass: "filed-control" },
            [
              _c(
                "el-upload",
                { staticClass: "upload-demo mt-2", attrs: { action: "" } },
                [
                  _c(
                    "el-button",
                    { attrs: { size: "small", type: "primary" } },
                    [_vm._v("上傳圖片")]
                  ),
                  _c(
                    "div",
                    {
                      staticClass: "el-upload__tip mark",
                      attrs: { slot: "tip" },
                      slot: "tip",
                    },
                    [_vm._v(" 僅能上傳 jpg/png 檔案，且大小不超過 500kb ")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ]),
        _c("div", { staticClass: "form-filed" }, [
          _vm._m(5),
          _c(
            "div",
            { staticClass: "filed-control" },
            [
              _c(
                "el-upload",
                { staticClass: "upload-demo mt-2", attrs: { action: "" } },
                [
                  _c(
                    "el-button",
                    { attrs: { size: "small", type: "primary" } },
                    [_vm._v("上傳圖片")]
                  ),
                  _c(
                    "div",
                    {
                      staticClass: "el-upload__tip mark",
                      attrs: { slot: "tip" },
                      slot: "tip",
                    },
                    [_vm._v(" 僅能上傳 jpg/png 檔案，且大小不超過 500kb ")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ]),
        _c("div", { staticClass: "form-filed" }, [
          _vm._m(6),
          _c(
            "div",
            { staticClass: "filed-control" },
            [
              _c(
                "el-upload",
                { staticClass: "upload-demo mt-2", attrs: { action: "" } },
                [
                  _c(
                    "el-button",
                    { attrs: { size: "small", type: "primary" } },
                    [_vm._v("上傳圖片")]
                  ),
                  _c(
                    "div",
                    {
                      staticClass: "el-upload__tip mark",
                      attrs: { slot: "tip" },
                      slot: "tip",
                    },
                    [_vm._v(" 僅能上傳 jpg/png 檔案，且大小不超過 500kb ")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ]),
      ]),
      _vm._m(7),
      _c("section", { staticClass: "content" }, [
        _c("div", { staticClass: "form-filed" }, [
          _vm._m(8),
          _c(
            "div",
            { staticClass: "filed-control" },
            [
              _c("date-picker", {
                staticClass: "w-25",
                attrs: { format: "YYYY-MM-DD", valueType: "format" },
              }),
            ],
            1
          ),
        ]),
        _c("div", { staticClass: "form-filed" }, [
          _vm._m(9),
          _c(
            "div",
            { staticClass: "filed-control" },
            [
              _c("date-picker", {
                staticClass: "w-25",
                attrs: { format: "YYYY-MM-DD", valueType: "format" },
              }),
            ],
            1
          ),
        ]),
      ]),
    ]),
    _c("div", { staticClass: "button-group" }, [
      _c(
        "button",
        {
          staticClass: "btn button-grey",
          attrs: { type: "button" },
          on: {
            click: function ($event) {
              return _vm.$router.go(-1)
            },
          },
        },
        [_vm._v("取消")]
      ),
      _c(
        "button",
        {
          staticClass: "btn button-green",
          attrs: { type: "button" },
          on: { click: _vm.createNewForm },
        },
        [_vm._v("建立題目")]
      ),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      {
        staticClass: "divider divider-left",
        staticStyle: { margin: "15px 0px 15px 15px" },
      },
      [
        _c("div", {
          staticClass: "divider-line",
          staticStyle: { height: "2px" },
        }),
        _c(
          "span",
          {
            staticStyle: {
              "font-size": "18px",
              padding: "4.5px 18px 4.5px 0px",
            },
          },
          [_vm._v(" 歡迎與感謝頁面 ")]
        ),
      ]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "form-filed" }, [
      _c("div", { staticClass: "form-label" }, [
        _c("div", { staticClass: "setting-label" }, [_vm._v("問卷名稱")]),
      ]),
      _c("div", { staticClass: "filed-control" }, [
        _c("input", {
          staticClass: "input-primary input-style",
          attrs: { maxlength: "200" },
        }),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "form-label" }, [
      _c("div", { staticClass: "setting-label" }, [_vm._v("歡迎文字")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "form-label" }, [
      _c("div", { staticClass: "setting-label" }, [_vm._v("感謝文字")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "form-label" }, [
      _c("div", { staticClass: "setting-label" }, [_vm._v("頁面背景圖片")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "form-label" }, [
      _c("div", { staticClass: "setting-label" }, [_vm._v("歡迎 Bannner")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "form-label" }, [
      _c("div", { staticClass: "setting-label" }, [_vm._v("感謝 Bannner")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      {
        staticClass: "divider divider-left",
        staticStyle: { margin: "15px 0px 15px 15px" },
      },
      [
        _c("div", {
          staticClass: "divider-line",
          staticStyle: { height: "2px" },
        }),
        _c(
          "span",
          {
            staticStyle: {
              "font-size": "18px",
              padding: "4.5px 18px 4.5px 0px",
            },
          },
          [_vm._v(" 一般設定 ")]
        ),
      ]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "form-label" }, [
      _c("div", { staticClass: "setting-label" }, [
        _vm._v("問卷有效期限 (起)"),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "form-label" }, [
      _c("div", { staticClass: "setting-label" }, [
        _vm._v("問卷有效期限 (訖)"),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }